import { UserService } from './../home/services/user.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

    constructor(public userService: UserService) { }

    public Auth_token: any;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let auth_token = localStorage.getItem('AUTH');
        let currentUser = localStorage.getItem('userdata');

        //check for the url, if it is login url then return

        if (req.url.includes('/login')) {
            return next.handle(req);
        } else
        {

            const reqh = req.clone({
            // setHeaders: {
            //     'Content-Type': 'application/json; charset=utf-8',
            //     'Accept': 'application/json, text/plain',
            //     'Authorization': `Bearer ${auth_token}`
            // }

            })
            return next.handle(reqh);
        }

    }

}
